<template>
    <div class="navBox fixed-top">
        <div class="menuBox ">
            <div class="logoNav">
                <div class="logo  flex flex-align-center flex-justify-start cursor" @click="goIndex">
                    <img style="height:40px;width:37px;" class="mx-2" src="@/assets/images/index/logo3.png" alt="">
                    <!-- <div class="fs-4 "> -->
                    <h1 class="m-0 fw-bold text-light">
                        慧训
                    </h1>
                    <!-- </div> -->
                    <!-- :collapse="isCollapse" :mode="menuMode"-->
                </div>
                <div class="el-icon-menu" v-show="isMobile" @click="showMenu" style="font-size:20px;">

                </div>
            </div>

            <el-collapse-transition>
                <el-menu v-if="isShowMenuItems" :default-active="changeRouter" router :mode="menuMode" class="el-menu-vertical-demo " style="" @select="handleSelect" text-color="#fff">
                    <el-menu-item class="" v-for="route in routers" v-if="!route.hidden" :key="route.path" :index="route.path" :route="route.path">
                        <span slot="title">{{route.meta.title}}</span>
                    </el-menu-item>
                </el-menu>
            </el-collapse-transition>
        </div>
    </div>

</template>

<script>
// import router from 
// import ScrollReveal from "scrollreveal"; 
export default {
    name: 'index',
    components: {

    },
    props: ['closeNav'],
    data() {

        return {
            routers: [],
            activeIndex: '1',
            menuMode: "horizontal",
            isCollapse: false,
            isShowMenuItems: false,
            isMobile: true,
        }
    },
    computed: {
        changeRouter() {
            return this.$route.path
        },
        changeMenuMode() {

        },

    },
    watch: {
        // isMobile(n) {
        //     this.$emit("changeMenuClose", n)
        // },
        closeNav(n) {
            this.isShowMenuItems = n
        }
    },
    created() {
        // console.log(this.$router.options.routes);
        this.routers = this.$router.options.routes
        this.activeIndex = this.routers[0].path
    },
    mounted() {
        this.changeMenuModes()
        window.addEventListener("resize", () => {
            this.changeMenuModes()
        })

    },
    methods: {

        goIndex() {
            // console.log();
            this.$router.push("/")
            // if (this.$route.path === "/") {
            //     return;
            // } else {

            // }
        },
        changeMenuModes() {
            let deviceWidth = window.innerWidth
            if (deviceWidth < 500) {
                this.menuMode = "vertical"
                this.isMobile = true
                this.isShowMenuItems = false;

            } else {
                this.isShowMenuItems = true
                this.isMobile = false
                this.menuMode = "horizontal"
            }
        },
        isCollapseFun() {
            this.isCollapse = !this.isCollapse
            return this.isCollapse;
        },
        showMenu() {
            this.isShowMenuItems = !this.isShowMenuItems
            this.$emit("changeMenuClose", this.isShowMenuItems)
        },
        handleSelect(key, keyPath) {}

    }
}
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.navBox {
    height:60px;
    width: 100%;
    background-image: linear-gradient(to bottom, rgba(18, 31, 53, .6), rgba(18, 31, 53, .3), rgba(18, 31, 53, 0)) !important;

    .menuBox {
        // background: rgba(18,31,53,.8);
        // height:60px;
        width: 70%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

    }

    .el-menu {
        // background-color:transparent!important;
        background: 0;
        //  background-image: linear-gradient(to bottom, rgba(18,31,53,0), rgba(18,31,53,.3),rgba(18,31,53,0)) !important;
    }
}

@media all and (max-width:500px) {
    .navBox {
        width: 100%;
        .menuBox {
            width: 100%;
            background: #143b4d;
        }

        .logoNav {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0;

            .logo {
                width: 90%;
            }

            .el-icon-menu {
                width: 10%;
                cursor: pointer;
                color: #fff;
            }
        }

        .el-menu {
            background: #143b4d;
            position: fixed;
            top: 60px;
            left: 0;
            z-index: 9999;
            width: 100%;
            border: none;

            .el-menu-item:focus {
                background: transparent;
                color: #3effe1;
            }

            .el-menu-item:hover {
                background: transparent;
            }

            .el-menu-item.is-active {
                color: #3effe1;
            }

            // display:none;
        }

        .logo {

            // flex-direction: column;
            // align-items: center;
            // justify-content: space-between;
        }

        // flex-direction:column;

        .el-menu-vertical-demo:not(.el-menu--collapse) {
            // width: 200px;
            // min-height: 400px;
        }
    }

}

.el-menu.el-menu--horizontal {
    border-bottom: none !important;
}

.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background: none !important;
}

.el-menu--horizontal>.el-menu-item:hover {
    background: none !important;
    border-bottom: 4px solid #3effe1 !important;
    color: #fff !important;
}

.el-menu--horizontal>.el-menu-item.is-active {
    background: none !important;
    border-bottom: 4px solid #3effe1 !important;
    color: #fff !important;
}
</style>
